import Spline from '@splinetool/react-spline';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';

import aligned from '@ui/styled/Aligned';
import fullWidth from '@ui/styled/FullWidth';

interface IFolxLoader {
	message?: string;
}

const AlignedColumn = fullWidth<IFlexColumn>(aligned<IFlexColumn>(FlexColumn));
const LoaderColumn = styled(AlignedColumn)`
	div {
		display: flex;
		justify-content: center;
	}
`;

const loadingMessage = `Hang tight. We are almost there...`;

const FolxLoader: FC<IFolxLoader> = ({ message = loadingMessage }) => {
	return (
		<LoaderColumn gap="sm" alignItems="center">
			<Spline scene="https://prod.spline.design/zVyZtjjMQWi1qcJo/scene.splinecode" />
			<BasicText variant="fineprintBold">{message}</BasicText>
		</LoaderColumn>
	);
};

export default FolxLoader;
